$(document).ready(function() {

  $('.vertical-thumbs').slick({
    infinite: true,
    vertical: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: '<i class="fa fa-angle-up"></i>',
    nextArrow: '<i class="fa fa-angle-down"></i>'
  });

  var sync1 = $("#sync1");
  var sync2 = $("#sync2");
  var slidesPerPage = 5; //globaly define number of elements per page
  var syncedSecondary = true;

  sync1.owlCarousel({
    items : 1,
    slideSpeed : 2000,
    nav: false,
    autoplay: false,
    dots: false,
    loop: false,
    responsiveRefreshRate : 200,
  }).on('changed.owl.carousel', syncPosition);

  sync2
  .on('initialized.owl.carousel', function () {
    sync2.find(".owl-item").eq(0).addClass("current");
  })
  .owlCarousel({
    items : slidesPerPage,
    dots: false,
    nav: false,
    slideBy: slidesPerPage, //alternatively you can slide by 1, this way the active slide will stick to the first item in the second carousel
    responsiveRefreshRate : 100,
    responsive:{
      0:{
        items:2
      },
      600:{
        items:2
      },
      1000:{
        items:5
      }
    }
  }).on('changed.owl.carousel', syncPosition2);

  function syncPosition(el) {
    //if you set loop to false, you have to restore this next line
    //var current = el.item.index;

    //if you disable loop you have to comment this block
    var count = el.item.count-1;
    var current = Math.round(el.item.index - (el.item.count/2) - .5);

    if(current < 0) {
      current = count;
    }
    if(current > count) {
      current = 0;
    }

    //end block

    sync2
    .find(".owl-item")
    .removeClass("current")
    .eq(current)
    .addClass("current");
    var onscreen = sync2.find('.owl-item.active').length - 1;
    var start = sync2.find('.owl-item.active').first().index();
    var end = sync2.find('.owl-item.active').last().index();

    if (current > end) {
      sync2.data('owl.carousel').to(current, 100, true);
    }
    if (current < start) {
      sync2.data('owl.carousel').to(current - onscreen, 100, true);
    }
  }

  function syncPosition2(el) {
    if(syncedSecondary) {
      var number = el.item.index;
      sync1.data('owl.carousel').to(number, 100, true);
    }
  }

  sync2.on("click", ".owl-item", function(e){
    e.preventDefault();
    var number = $(this).index();
    sync1.data('owl.carousel').to(number, 300, true);
  });
});
(function($) {
  "use strict";
  function owlsync() {
    $('.slider-for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.slider-nav'
    });
    $('.slider-nav').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: '.slider-for',
      dots: false,
      arrows: false,
      centerMode: false,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 1200,
          setting: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 991,
          setting: {
            slidesToShow: 2
          }

        },
        {
          breakpoint: 767,
          setting: {
            slidesToShow: 1
          }

        }
      ]
    });
  }

  function stickyHeader() {
    if ($(window).width() >992){
      if ($('.header-sticky').length) {
        var header = $('header.header'),
            scrollPosition = 0,
            headerTopHeight = $('header.header .header-top').outerHeight(),
            checkpoint = 300;
        $(window).scroll(function(event) {
          var currentPosition = $(this).scrollTop();
          if (currentPosition < scrollPosition) {
            // On top
            if (currentPosition == 0) {
              header.removeClass('navigation--sticky navigation--unpin navigation--pin');
              header.css("margin-top", 0);
            }
            // on scrollUp
            else if (currentPosition > checkpoint) {
              header.removeClass('navigation--unpin').addClass('navigation--sticky navigation--pin');
              $('.ps-mobile-nav').removeClass('active');
            }
          }
          // On scollDown
          else {
            if (currentPosition > checkpoint) {
              header.addClass('navigation--unpin').removeClass('navigation--pin');
              header.css("margin-top", -headerTopHeight);
            }
          }
          scrollPosition = currentPosition;
        });
      }
    }

  }

  function stickySidebar() {
    if ($(window).width() >1200){
      if ($('.sidebar-collection').length) {
        var header = $('.header'),
            scrollPosition = 0,
            header = $('.header').outerHeight(),
            main = $('.ps-main').outerHeight(),
            footer = $('footer').outerHeight(),
            checkpoint = 300;
        $(window).scroll(function(event) {
          var currentPosition = $(this).scrollTop();
          var currentPositionBottom = $('body').outerHeight() - $(window).scrollTop() ;
          if (currentPosition > checkpoint &&  currentPositionBottom > 1450) {
            $('.sidebar-collection').addClass('fixed');
          } else {
            $('.sidebar-collection').removeClass('fixed');
          }
          scrollPosition = currentPosition;
        });
      }
    }

  }

  function search(){
    // Popup for Menu and Search Links in the Header
    $('.search-toggle').on('click', function () {
      $('.home-search').fadeIn(250);
      $('.home-search .search-query').focus();
    });
    $('.close-search').on('click', function () {
      $('.home-search').fadeOut(250);
    });
  }
  function faq(){
    var Accordion = function(el, multiple) {
      this.el = el || {};
      this.multiple = multiple || false;

      // Variables privadas
      var links = this.el.find('.link');
      // Evento
      links.on('click', {el: this.el, multiple: this.multiple}, this.dropdown)
    }

    Accordion.prototype.dropdown = function(e) {
      var $el = e.data.el;

      $(this).next().slideToggle();
      $(this).parent().toggleClass('open');

      if (!e.data.multiple) {
        $el.find('.submenu').not($(this).next()).slideUp().parent().removeClass('open');
      };
    }	

    var accordion = new Accordion($('#accordion'), false);

  }
  function masonry() {
    var masonryTrigger = $('.ps-masonry');
    if (masonryTrigger.length > 0) {
      masonryTrigger.imagesLoaded(function() {
        masonryTrigger.masonry({
          columnWidth: '.grid-sizer',
          itemSelector: '.grid-item'
        });
      });
      var filters = masonryTrigger.closest('.masonry-root').find('.ps-masonry__filter > li > a');
      filters.on('click', function() {
        var selector = $(this).attr('data-filter');
        filters.find('a').removeClass('current');
        $(this).parent('li').addClass('current');
        $(this).parent('li').siblings('li').removeClass('current');
        $(this).closest('.masonry-root').find('.ps-masonry').isotope({
          itemSelector: '.grid-item',
          isotope: {
            columnWidth: '.grid-sizer'
          },
          filter: selector
        });
        return false;
      });
    }
  }
  function backToTop() {
    var scrollPos = 0;
    var element = $('#back2top');
    $(window).scroll(function() {
      var scrollCur = $(window).scrollTop();
      if (scrollCur > scrollPos) {
        // scroll down
        if (scrollCur > 500) {
          element.addClass('active');
        } else {
          element.removeClass('active');
        }
      } else {
        // scroll up
        element.removeClass('active');
      }

      scrollPos = scrollCur;
    });

    element.on('click', function() {
      $('html, body').animate({
        scrollTop: '0px'
      }, 800);
    })
  }
  function headerToggle() {
    $('.dropdown-toggle').on("click", function (e) {
      $(this).next().toggleClass("active");
      e.preventDefault();
    }); 
    //     $('.dropdown-content li').on("click", function () {
    //       $(this).parent().slideUp(300);
    //     }); 
  }
  function filter_sidebar() {
    $('.filter-toggle').on("click", function (e) {
      $('body').addClass('show');
    }); 
    $('.exit-canvas, .overlay').on("click", function (e) {
      $('body').removeClass('show');
    }); 
  }
  function view_column() {
    if ($('.collection-view').length > 0) {
      $('.collection-view a').on("click", function (e) {
        var col = $(this).data('col');
        $('.collection-view a').removeClass('active');
        $(this).addClass('active');
        $('.products-grid').removeClass('two three four five six');
        $('.products-grid').addClass(col);
      }); 
    }
  }
  function sticky_sidebar() {
    if ($('.ps-sticky').length) {
      var checkPoint = 1200,
          windowWidth = $(window).innerWidth();
      // mobile
      if (checkPoint > windowWidth) {
        var stickySidebar = new StickySidebar('.ps-sticky .ps-sticky__target');
        stickySidebar.destroy();
      }
      else {
        var sticky = $('.ps-sticky');
        if (sticky.length > 0) {
          var sticky_init = new StickySidebar('.ps-sticky .ps-sticky__target', {
            topSpacing: 20,
            bottomSpacing: 20,
            containerSelector: '.ps-sticky'
          });
        }
      }
    }

  }
  function portfolio(){
    // init Isotope
    if($('.isotope').length){
      var $container = $('.isotope').isotope({
        itemSelector: '.element-item',
        layoutMode: 'fitRows',
        getSortData: {
          name: '.name',
          symbol: '.symbol',
          number: '.number parseInt',
          category: '[data-category]',
          weight: function(itemElem) {
            var weight = $(itemElem).find('.weight').text();
            return parseFloat(weight.replace(/[\(\)]/g, ''));
          }
        }
      });

      // filter functions
      var filterFns = {
        // show if number is greater than 50
        numberGreaterThan50: function() {
          var number = $(this).find('.number').text();
          return parseInt(number, 10) > 50;
        },
        // show if name ends with -ium
        ium: function() {
          var name = $(this).find('.name').text();
          return name.match(/ium$/);
        }
      };

      // bind filter button click
      $('#filters').on('click', 'button', function() {
        var filterValue = $(this).attr('data-filter');
        // use filterFn if matches value
        filterValue = filterFns[filterValue] || filterValue;
        $container.isotope({
          filter: filterValue
        });
      });

      // bind sort button click
      $('#sorts').on('click', 'button', function() {
        var sortByValue = $(this).attr('data-sort-by');
        $container.isotope({
          sortBy: sortByValue
        });
      });

      // change is-checked class on buttons
      $('.button-group').each(function(i, buttonGroup) {
        var $buttonGroup = $(buttonGroup);
        $buttonGroup.on('click', 'button', function() {
          $buttonGroup.find('.is-checked').removeClass('is-checked');
          $(this).addClass('is-checked');
        });
      });

      //****************************
      // Isotope Load more button
      //****************************
      var initShow = 12; //number of items loaded on init & onclick load more button
      var counter = initShow; //counter for load more button
      var iso = $container.data('isotope'); // get Isotope instance

      loadMore(initShow); //execute function onload

      function loadMore(toShow) {
        $container.find(".hidden").removeClass("hidden");

        var hiddenElems = iso.filteredItems.slice(toShow, iso.filteredItems.length).map(function(item) {
          return item.element;
        });
        $(hiddenElems).addClass('hidden');
        $container.isotope('layout');

        //when no more to load, hide show more button
        if (hiddenElems.length == 0) {
          jQuery("#load-more").hide();
        } else {
          jQuery("#load-more").show();
        };

      }

      //append load more button
      $container.after('<button id="load-more"> Load More</button>');

      //when load more button clicked
      $("#load-more").click(function() {
        if ($('#filters').data('clicked')) {
          //when filter button clicked, set initial value for counter
          counter = initShow;
          $('#filters').data('clicked', false);
        } else {
          counter = counter;
        };

        counter = counter + initShow;

        loadMore(counter);
      });

      //when filter button clicked
      $("#filters").click(function() {
        $(this).data('clicked', true);

        loadMore(initShow);
      });
    }

  }
  function add(){
    //deal
    $('[data-date]').each(function() {
      var $this = $(this), finalDate = $(this).data('date');
      $this.countdown(finalDate, function(event) {
        $this.html(event.strftime('<div class="deals-time hour"><div class="num">%H</div> <div class="title-time">hours</div></div><div class="deals-time minute"><div class="num">%M</div><div class="title-time">minutes</div></div><div class="deals-time second"><div class="num">%S</div><div class="title-time">seconds</div></div>'));
      });
    }); 
    //special tab
    $("#sync2 .owl-item .item").click(function() {
      $("#sync2 .owl-item .item").removeClass('checked');
      $(this).addClass('checked');
    });
    //vertical-tab
    $('.ps-product-collection .tab-toggle >li').on("click", function () {
      var show = $(this).data('id');
      $('.ps-product-collection .tab-content').fadeOut(0);
      $('.ps-product-collection .tab'+show).fadeIn(500);
    });
    $('.ps-home-about--2 .tab-toggle >li').on("click", function () {
      var show = $(this).data('id');
      $('.ps-home-about--2 .tab-content').fadeOut(0);
      $('.ps-home-about--2 .tab'+show).fadeIn(500);
    });
    //cart
    if ($(window).width() < 1200) {
      $('.ps-cart__toggle').on("click", function () {
        $(this).next().toggle();
      });
    }

  }

  function countUp() {
    var number = $('.number');

    number.each(function() {
      var el = $(this);
      el.text('0');

      var waypoint = new Waypoint({
        element: el,
        handler: function(direction) {
          el.countTo({
            speed: '1500',
            refreshInterval: 50
          });
          this.destroy();
        },
        offset: function() {
          return Waypoint.viewportHeight() - el.outerHeight() - 100;
        }
      });
    });
  }
  function sku_change(){
    if ($('.sku').length > 0) {
      $('.swatch-element ').on("click", function (e) {
        var sku = $(this).data('variant');
        $('.sku span').html(sku); 
      })
    }
  }

  $(document).ready(function() {
    masonry();
    stickyHeader();
    faq();
    filter_sidebar();
    view_column();
    search();
    sku_change();
    owlsync();
    portfolio();
    new WOW().init();
    headerToggle();
    add();
    countUp();
    //     stickySidebar();
    //product hover
    $(".ps-shoe").hover(function(){
      $(this).find(".lazy").lazy();
    });
    $("img.lazy").hover(function(){
      var src = $(this).data("img");
      var id = $(this).data("id");
      $(".product-"+ id).find(".main-img").attr("src", src);
    });
    //variant product page
    $(".ps-product__style li").click(function(){
      var src = $(this).data("img");
      var id = $(this).data("id");
      $(".ps-product__style li").removeClass("active");
      $(this).addClass("active");
      $("#product-featured-image").attr("src", src);
      $(".zoomWindow").css('background-image', 'url('+ src +')');
    });
    //auto height
    $('.row .auto-height').matchHeight({byRow: true, property: 'height'});
    console.log(1);
  });

  $(window).on('load resize', function() {
    sticky_sidebar();
  });

})(jQuery);
